import { deepMerge } from 'js/utils/Utils'

import Common from 'js/_core/Common'

const defaults = {
  instanceName: 'careerArticleLoadMore',
  $names: {
    list: '[data-career-article-list]',
    item: '[data-career-article-item]',
    foot: '[data-career-article-foot]',
    more: '[data-career-article-more]',
  },
  // 初期表示件数 兼 VIEW MORE 1回あたりの追加表示件数
  step: 6,
}

export default class CareerArticleLoadMore {
  $contentRoot = document
  $list = null
  $items = []
  $foot = null
  $more = null
  visibleCount = 0

  constructor(options = {}) {
    deepMerge(this, defaults, options)
  }

  init() {
    this._set$()

    if (!this.$list || !this.$items.length) return

    this._setInitialState()
    this._addEventListeners()
  }

  destroy() {
    this._removeEventListeners()

    this.$list = null
    this.$items = []
    this.$foot = null
    this.$more = null
    this.visibleCount = 0
  }

  _set$() {
    this.$list = this.$contentRoot.querySelector(this.$names.list)
    if (!this.$list) return

    this.$items = Array.prototype.slice.call(this.$list.querySelectorAll(this.$names.item))
    this.$more = this.$contentRoot.querySelector(this.$names.more)
    this.$foot = this.$contentRoot.querySelector(this.$names.foot)
  }

  _setInitialState() {
    // マークアップ側でhiddenが付いていない件数を初期表示件数として扱う
    this.visibleCount = this.$items.filter(($item) => !$item.hidden).length

    if (!this.visibleCount || this.visibleCount === this.$items.length) {
      this.visibleCount = Math.min(this.step, this.$items.length)
      this.$items.forEach(($item, i) => {
        $item.hidden = i >= this.visibleCount
      })
    }

    this._updateMoreState()
  }

  _addEventListeners() {
    if (this.$more) {
      this.$more.addEventListener('click', this._onClick, false)
    }
  }

  _removeEventListeners() {
    if (this.$more) {
      this.$more.removeEventListener('click', this._onClick, false)
    }
  }

  _onClick = () => {
    this.showNext()
  }

  showNext() {
    if (this._isAllVisible()) return

    const nextCount = Math.min(this.visibleCount + this.step, this.$items.length)

    for (let i = this.visibleCount; i < nextCount; i++) {
      this.$items[i].hidden = false
    }

    this.visibleCount = nextCount

    this._updateMoreState()
    this._refreshLayout()
  }

  _isAllVisible() {
    return this.visibleCount >= this.$items.length
  }

  _updateMoreState() {
    if (!this._isAllVisible()) return

    // 全件表示しきったらVIEW MOREを消す
    if (this.$more) {
      this.$more.disabled = true
    }
    if (this.$foot) {
      this.$foot.hidden = true
    } else if (this.$more) {
      this.$more.hidden = true
    }
  }

  _refreshLayout() {
    // 追加表示でレイアウトの高さが変わるため、WebGLの位置とサイズを取り直す
    Common.webgl?.onResize()
  }
}
